import {format} from '../../filters/format';
import {checkHttpsAndWrapUrlsInCorsProxy} from '../../common/util/url-util';
import {getProxyPrefix} from '../../common/util/url-util'

export function renderList({points}) {
  return points
    .filter(point => point.series.visible)
    .map(point => {
      let userOptions = point.series.userOptions;
      let marker = point.point.options.marker;
      let xValue = userOptions.noDateInTooltip ? point.x : format(point.x, point.series.options.dateFormat || 'date');
      let trimmedTooltip = _.truncate(userOptions.tooltipName, {length: 40, separator: /,? +/, omission: '...'});
      let text = `<div class="x">${xValue}</div>
                  <div class="series">${trimmedTooltip || userOptions.name}</div>
                  <div class="y" style="color: ${point.color}">${format(point.y, point.series.options.format)}</div>`;

      if (marker)
        text += `<div style="color: ${marker.fillColor}">${marker.tooltipText}</div>`;

      return text;
    }).join('');
};

export function renderTable({points, comparison}) {
  let point = points[0];
  let text = '';

  if(points[0].series.userOptions.noDateInTooltip) {
    text = point.x;
  } else {
    text = `<div class="x">${format(point.x, point.series.options.dateFormat || 'date')}</div>`;
  }

  if(_.get(point, 'point.options.tooltipTitle')) {
    text += `<div class="x u-mb0">${point.point.options.tooltipTitle}</div>`;
  }

  text += `<table class="table-series series">`;
  points
    .filter(point => point.series.visible)
    .map(point => {
      let userOptions = point.series.userOptions;
      let marker = point.point.options.marker;
      let tooltipValue = _.get(point, 'point.options.tooltipValue') || format(point.y, point.series.options.format);
      let trimmedTooltip = _.truncate(userOptions.tooltipName, {length: 40, separator: /,? +/, omission: '...'});

      text += `<tr class="table-series__row">
        <td class="table-series__name">${trimmedTooltip || userOptions.name}<td>
        <td style="color: ${point.color}">${tooltipValue}<td>`;

      if (marker)
        text += `<td style="color: ${marker.fillColor}">${marker.tooltipText}</td>`;

      text += `</tr>`;
    });
  text += `</table>`;
  return text;
};

export function renderCategory({points, comparison}) {
  let point = points[0];
  let text = "";
  let tooltipTitleRightHtml = "";

  if (point.point.options.tooltipTitleRight) {
    tooltipTitleRightHtml = `<div style="float:right; padding-right:4px">${point.point.options.tooltipTitleRight}</div>`;
  }
  if (point.point.options.tooltipTitle) {
    text += `<div class="x u-mb0">${point.point.options.tooltipTitle}${tooltipTitleRightHtml}</div>`;
  }
  if(!_.isEmpty(point.point.aggregateValuesInfo)) {
    text += `<table class="table-series series">`;
    _.forEach(point.point.aggregateValuesInfo, (info, index) => {
      text += `<tr class="table-series__row">
        <td class="table-series__name">${info.key}<td>
        <td style="color: ${info.color||(points[index]||point).color}">${info.tooltipValue}<td>`;
    });
  } else {
    let tooltipValue = _.get(point, 'point.options.tooltipValue') || format(point.y, point.series.options.format);
    
    text += `<table class="table-series series">
            <tr class="table-series__row">
            <td class="table-series__name">${point.point.options.name || point.key}<td>
            <td style="color: ${point.color}">${tooltipValue}<td>`;
  }
  return text;
};

export function renderCreative({points, comparison}) {
  let point = points[0];
  let creative = point.point.options.creative;
  let text = `<div class="x u-mb0">${creative.variationName}</div>
              <div class="series u-mv--" style="min-width: 145px;">
                <div class="c-switch c-switch--single  c-switch--single--plain">
                  <input type="radio" class="c-switch__input" id="swactiveactive" name="swactive" ${creative.active ? 'checked=""' : ''}>
                  <label for="swactiveactive" class="c-switch__label" onclick="return false;">active</label>
                  <input type="radio" class="c-switch__input" id="swactiveinactive" name="swactive" ${creative.active ? '' : 'checked=""'}>
                  <label for="swactiveinactive" class="c-switch__label" onclick="return false;">inactive</label>
                  <div class="c-switch__mark"></div>
                </div>
                ${point.key}
                <div class="float-right" style="color: ${point.color}">${format(point.y, point.series.options.format)}</div>
              </div>`;

  if(creative.size.indexOf('x') > -1) {
    let [width,height] = creative.size.split('x').map(v => parseInt(v, '10'));
    let minHeight = width / height > 1.5 ? '' : 'min-height: 99px;';
    text += `<div class="text-center" style="min-width: 145px;${minHeight}">
              <img class="c-thumbnail" src="${checkHttpsAndWrapUrlsInCorsProxy(creative.url, getProxyPrefix(window.location.host))}">
            </div>`;
  }

  return text;
};

export function tooltipFormatter(tooltip) {
  let comparison = tooltip.chart.options.comparison;
  let points = (this.points || [this]);

  switch(points[0].series.userOptions.tooltipType || tooltip.chart.options.tooltipType) {
    case 'category':
      return renderCategory({points});
    case 'creative':
      return renderCreative({points});
    default: {
      if (points.length == 1 || (comparison && points.length == 2)) {
        return renderList({points});
      } else {
        return renderTable({points, comparison});
      }
    }
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/tooltipFormatter.js
 **/